(function () {
	'use strict';

	/**
	 * __Auth Service - 0.3.2 - 22 APR 2019
	 * 
	 * User Authentication Service.
     *
     *   * Internal Dependencies:
     *
     * __Utils
     *
     * External Dependencies:
     * 
     * AngularJS     1.3.0   +     - http://angularjs.org
     * lodash        3.9.3   +     - http://lodash.com
     *
     *-------------------------------------------------------- */

	angular.module("lw.auth", []).
		service("__Auth", [
			'__Utils', '$rootScope', '$transitions', __Auth
		]);

	function __Auth(__Utils, $rootScope, $transitions) {

		this.authConfig = {
			redirects: {
				guestOnly: 'dashboard',
				authorized: 'login',
				accessDenied: 'unauthorized'
			}
		};

		// check if app lavel auth config is there
		if (__globals && __globals.authConfig) {

			_.assign(this.authConfig, __globals.authConfig);

		};

		/**
	      * Check if user logged in or not
	      *
	      * @return boolean
	      *---------------------------------------------------------------- */

		this.isLoggedIn = function () {

			return (this.authInfo('authorized') === true) ? true : false;

		};

	    /**
	      * Get user auth information
	      *
	      * @param string key 
	      *
	      * @return object value / object
	      *---------------------------------------------------------------- */

		this.authInfo = function (key) {

			if (key && _.has(window.__appImmutables.auth_info, key)) {

				return window.__appImmutables.auth_info[key];

			} else {

				return window.__appImmutables.auth_info;

			}

		};

	    /**
	      * Get user auth information
	      *
	      * @param string key 
	      *
	      * @return object value / object
	      *---------------------------------------------------------------- */

		this.resetAuthInfo = function (authInfo) {

			if (authInfo && _.isObject(authInfo)) {

				window.__appImmutables.auth_info = authInfo;

			} else {

				window.__appImmutables.auth_info = {};
			}

			$rootScope.$broadcast('lw.auth.event.reset', authInfo);
		}

    	/**
	      * Verify route for access
	      *
	      * @param object state - $state provider
	      *
	      * @return boolean
	      *---------------------------------------------------------------- */

		this.verifyRoute = function (state) {

			this.state = state;

			var redirects = this.authConfig.redirects,
				_auth = this;

			$transitions.onSuccess({}, function (transition) {

				var stateObj = transition.to(),
					paramObj = transition.params();

				$rootScope.$broadcast('lw.events.state.change_start', stateObj, paramObj);

				var accessObject = _.has(stateObj, 'access') ? stateObj.access : false;

				if (accessObject == false) { // check if page public or not

					return false;

				}

				if (accessObject && _.has(accessObject, 'guestOnly') && _auth.isLoggedIn()) {

					__Utils.log('__Auth:: Access denied for ' + stateObj.name + ' ( guest only access ) state');

					state.go(redirects.guestOnly);

					event.preventDefault();

					return false;
				}

				var accessKeys = _auth.authInfo();

				if (accessObject && _.has(accessObject, 'designation')) {

					// check if access to multiple designations
					if (_.isArray(accessObject.designation)
						&& _.includes(accessObject.designation, accessKeys.designation) === false) {

						__Utils.log('__Auth:: Access denied for ' + stateObj.name + ' state ( not allowed )');

						state.go(redirects.accessDenied);

						event.preventDefault();

						return false;
						// if not check access for single
					} else if (!_.isArray(accessObject.designation) && accessObject.designation !== accessKeys.designation) {

						__Utils.log('__Auth:: Access denied for single' + stateObj.name + ' state ( not allowed )');

						state.go(redirects.accessDenied);

						event.preventDefault();

						return false;

					}

				}

				if (accessObject && _.has(accessObject, 'authority')) {

					// check if routes available for access
					if (_.includes(__globals.appImmutable('availableRoutes'), accessObject.authority) === false) {

						__Utils.log('__Auth:: Access denied for ' + stateObj.name + ' state ( not allowed )');

						state.go(redirects.accessDenied);

						event.preventDefault();

						return false;

					}

				}

				if (accessObject && !_.has(accessObject, 'guestOnly') && !_auth.isLoggedIn()) {

					__Utils.log('__Auth:: Access denied for ' + stateObj.name + ' ( authorized only ) state');

					_auth.registerIntended({
						name: stateObj.name,
						params: paramObj,
						except: ['login', 'logout']
					}, function () {

						state.go(redirects.authorized);

					});

					event.preventDefault();

					return false;
				}

			});


		};

        /**
          * Get intended state object
          *
          *
          * @return object
          *---------------------------------------------------------------- */

		this.getIntendedState = function () {

			return __globals.intended;
		};

        /**
          * Check if any child state exist
          *
          *
          * @return object
          *---------------------------------------------------------------- */

		this.isIntendedStateParentRegistered = function (stateObj) {

			return __globals.intended ? _.includes(__globals.intended.name + '.', stateObj.name) : false;
		};

        /**
          * Register intended state
          *
          * @param object stateObj - object containing required values for name & options are params, except, preventOverride
          *
          * @return void
          *---------------------------------------------------------------- */

		this.registerIntended = function (stateObj, callbackFunction) {

			var exceptStates = (_.has(stateObj, 'except') && _.isArray(stateObj.except)
				&& _.includes(stateObj.except, stateObj.name)) ? true : false;

			if (!exceptStates && !this.isIntendedStateParentRegistered(stateObj)) {

				__globals.intended = stateObj;

			}

			if (callbackFunction && _.isFunction(callbackFunction)) {

				callbackFunction.call(this, __globals.intended);

			}

		};

        /**
          * redirect to intended state
          *
          * @param string state - fallbackState state
          *
          * @return void
          *---------------------------------------------------------------- */

		this.redirectIntended = function (fallbackState) {

			if (__globals.intended && __globals.intended.name) {

				this.state.go(__globals.intended.name, __globals.intended.params);

			} else if (fallbackState) {

				this.state.go(fallbackState);

			}

			__globals.intended = {};

		};

    	/**
	      * Set authentication information
	      *
	      * @param object authInfo 
	      *
	      * @return void
	      *---------------------------------------------------------------- */

		/*
			  Notes: authInfo should have following properties
				  authorization ( token string) ,
				  authorized ( boolean )
			  designation ( numeric access level code ),
			  reaction_code ( standard reaction code )
		*/

		this.checkIn = function (authInfo, callbackFunction) {

			this.resetAuthInfo(authInfo);

			if (callbackFunction && _.isFunction(callbackFunction)) {

				callbackFunction.call(this, authInfo);

			}

		};

		/**
		  * Reset authentication information
		  *
		  * @param function callbackFunction 
		  *
		  * @return void
		  *---------------------------------------------------------------- */

		this.refresh = function (callbackFunction) {

			var authInfo = window.__appImmutables.auth_info;

			this.resetAuthInfo(authInfo);

			if (callbackFunction && _.isFunction(callbackFunction)) {

				callbackFunction.call(this, authInfo);

			}

		};

	    /**
		  * flush authentication information
		  *
		  * @param object authInfo 
		  * @param function callbackFunction 
		  *
		  * @return void
		  *---------------------------------------------------------------- */

		this.checkOut = function (authInfo, callbackFunction) {

			var authInfo = (authInfo && _.isObject(authInfo)) ? authInfo : {};

			this.resetAuthInfo(authInfo);

			if (callbackFunction && _.isFunction(callbackFunction)) {

				callbackFunction.call(this);
			}

		};

	};

})(); 